<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="700px">
      <template v-slot:activator="{ onShow }">
        <v-btn color="primary" class="btn-next" v-bind:disabled="!habilitado" v-on="onShow"
          @click="prepareDialog">Confirmar subsanación</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Confirmar subsanación</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="phoneForm">
              <v-row v-if="!modoCodigo">
                <v-col cols="12">
                  Le enviaremos por SMS un código para que pueda firmar este documento.
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Teléfono" required v-model="telefonoFirma" @paste.prevent
                    :rules="[validationRules.required, validationRules.phone]" counter="9"
                    v-bind:disabled="isLoading"></v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="mt-2">
                  <v-btn class="btn-popup" v-bind:loading="isLoading" @click="solicitarCodigoFirmaSubsanacion"
                    color="primary">
                    Recibir código
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>

            <v-form ref="codeForm">
              <v-row v-if="modoCodigo">
                <v-col cols="12">
                  Introduce el código que te hemos enviado al número {{ telefonoFirma }} y descarga el documento.
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Código de descarga" required v-model="codigo" ref="codeTextField"
                    v-bind:error-messages="codeErrorMessage" :rules="[validationRules.codigoFirma]"
                    v-bind:disabled="isLoading" counter="5"></v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="mt-2">
                  <v-btn class="btn-popup" v-bind:loading="isLoading" @click="firmarSubsanacion" color="primary">
                    Confirmar subsanación
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn class="btn-link" color="primary" float="left" v-if="modoCodigo" text @click="modoCodigo = false"
            v-bind:disabled="isLoading">Enviar otro código</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#124D91" text class="btn-link" @click="showDialog = false"
            v-bind:disabled="isLoading">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
import api from '@Base/services/auditoriaService'
import StepBase from './StepBase'

export default {
  name: 'FirmarDialog',
  mixins: [StepBase],
  props: ['idFirmaDocumento', 'habilitado'],
  data() {
    return {
      isLoading: false,
      showDialog: false,
      telefono: null,
      codigo: null,
      modoCodigo: false,
      telefonoFirma: null,
      codeErrorMessage: null
    }
  },
  computed: {
    tokenGestion() {
      return this.$store.state.solicitud.tokenGestion;
    }
    ,
  },
  methods: {
    open: function () {
      this.showDialog = true;
    },
    prepareDialog: function () {
      this.telefonoFirma = null;
      this.codigo = null;
      this.modoCodigo = false;
      this.showDialog = true;
    },
    solicitarCodigoFirmaSubsanacion: function () {

      if (!this.$refs.phoneForm.validate()) {
        return;
      }

      this.isLoading = true;
      this.codigo = null;

      var signCode = {
        idFirmaDocumento: this.idFirmaDocumento,
        numeroTelefono: this.telefonoFirma
      }
      api.solicitarCodigoFirmaSubsanacion(signCode,
        res => {
          console.log(res);
          this.isLoading = false;
          this.modoCodigo = true;
        },
        error => {
          console.log(error);
          this.isLoading = false;
          this.$emit('alert-event', { text: 'Error al solicitar código de descarga', color: 'red' });
          console.log(error);
        })
    },
    firmarSubsanacion: function () {

      if (!this.$refs.codeForm.validate()) {
        return;
      }

      this.isLoading = true;

      var signCode = {
        idFirmaDocumento: this.idFirmaDocumento,
        numeroTelefono: this.telefonoFirma,
        codigo: this.codigo
      }

      api.firmarSubsanacion(signCode,
        res => {
          console.log(res);
          this.isLoading = false;
          this.modoCodigo = false;
          this.showDialog = false;
          this.$emit('firmada');
        },
        error => {
          console.log(error);
          this.isLoading = false;
          this.codeErrorMessage = "El código introducido es incorrecto";
        })
    }
  },
}
</script>